// extracted by mini-css-extract-plugin
export var aircallIframe = "_i8-3";
export var fabContainer = "_i8-5";
export var fabRinging = "_i8-6";
export var loadingOverlay = "_i8-4";
export var pulse = "_i8-7";
export var widgetContent = "_i8-2";
export var widgetPanel = "_i8-0";
export var widgetPanelExpanded = "_i8-1";